import { Injectable, EventEmitter } from '@angular/core';
import * as Rx from 'rxjs';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { Sections, rangeData, LifeStyleQuestion, ErrorMsgModel } from '../model/lifestyle.model';
import {
  RefJsonQuestion, MedicationQuestionStoreModel, tabSquareActiveModel, TabQuesObjList,
  CurrentMedConToDisplay, PayloadObjFromStore, SubAndClassificationModel,
  AccordBtnModel, BackDataStoreModel, EditMedIndexModel
} from '../model/mcUserJourney.model';
import { fakeAsync } from '@angular/core/testing';
import { UnderWritingData } from '../model';
import { RegisterBackNavModel } from 'src/app/model/registerBackNavModel';


@Injectable()
export class SyncService {
  constructor() { }

  public medicalConditionJson = new BehaviorSubject<Sections[]>([]);

  public businessValidationEvent = new Subject<any>();

  public medicationJson = new BehaviorSubject<Sections[]>([]);

  public rangeValidationJson = new BehaviorSubject<rangeData[]>([]);

  //public accordionQues = new BehaviorSubject<LifeStyleQuestion>(null);

  accordionQuesEmitter = new EventEmitter();

  public initialQuestionJson = new BehaviorSubject<CurrentMedConToDisplay>(new CurrentMedConToDisplay());

  public mcDashboardObj = new BehaviorSubject<boolean>(false);

  public refJsonWithMappingQId: RefJsonQuestion[] = [];

  public tabQuesObjList: TabQuesObjList[] = [];

  public activeTabObjList: tabSquareActiveModel[] = [];

  public subAndClassificationObj: SubAndClassificationModel[] = [];

  public payLoadObjAndIndexFromStore: PayloadObjFromStore;

  public accordObj: AccordBtnModel;

  public accordIndexToPrepareBackEndJson: number[] = [];

  public errorValue: ErrorMsgModel[] = [];

  public currentBackNavData = new BehaviorSubject<BackDataStoreModel>(new BackDataStoreModel());

  public currentMedConditionIndex = new BehaviorSubject<EditMedIndexModel>(new EditMedIndexModel());

  public isEditModeCondition = new BehaviorSubject<boolean>(false);

  public registerBackData = new BehaviorSubject<RegisterBackNavModel>(new RegisterBackNavModel());

  setPayLoadObjAndIndexFromStore(payloadObj: UnderWritingData, indexToSearchFromStore: number) {
    let temp: PayloadObjFromStore = new PayloadObjFromStore();
    temp.indexNumberToSearch = indexToSearchFromStore;
    temp.payloadObj = payloadObj;
    this.payLoadObjAndIndexFromStore = temp;
  }

  getPayLoadObjAndIndexFromStore(): PayloadObjFromStore {
    return this.payLoadObjAndIndexFromStore;
  }

  setTabSquareAsActive(value: tabSquareActiveModel[]) {
    this.activeTabObjList = value;
  }

  getTabSquareAsActive(): tabSquareActiveModel[] {
    return this.activeTabObjList;
  }

  setMedicationQuestionList(temp: MedicationQuestionStoreModel) {
    if (temp) {
      if (this.tabQuesObjList.length > 0) {
        let result = this.tabQuesObjList.find((element) => element.quesToMap === temp.medQuesId);
        if (result) {
          this.removeDuplicateIndex(temp);
        }
        else {
          this.createAnNewMapQIdForTabObjList(temp);
        }
      }
      else {
        this.createAnNewMapQIdForTabObjList(temp);
      }
    }
  }

  createAnNewMapQIdForTabObjList(temp: MedicationQuestionStoreModel): void {
    let tempTabObj = new TabQuesObjList();
    tempTabObj.quesToMap = temp.medQuesId;
    tempTabObj.quesListToStore = [temp];
    this.tabQuesObjList.push(tempTabObj);
  }

  removeDuplicateIndex(temp: MedicationQuestionStoreModel): void {
    // removed duplicate index if any
    this.tabQuesObjList.forEach(element => {
      if (element.quesToMap === temp.medQuesId) {
        let i = element.quesListToStore.length;
        while (i--) {
          if ((element.quesListToStore[i].indexToSave === temp.indexToSave) && (element.quesListToStore[i].medQuesId === temp.medQuesId)) {
            element.quesListToStore.splice(i, 1);
          }
        }
        element.quesListToStore.push(temp);
        element.quesListToStore.sort((a: any, b: any): number => {
          return a.indexToSave - b.indexToSave;
        });
      }
    });
  }

  deleteIndexForMedicationQuestionList(indexToDelete: number, quesIdToSplice: string) {
    if (indexToDelete || indexToDelete === 0) {
      this.tabQuesObjList.forEach(element => {
        if (element.quesToMap === quesIdToSplice) {
          let i = element.quesListToStore.length;
          while (i--) {
            if ((element.quesListToStore[i].indexToSave === indexToDelete.toString())) {
              element.quesListToStore.splice(i, 1);
            }
          }
          element.quesListToStore.sort((a: any, b: any): number => {
            return a.indexToSave - b.indexToSave;
          });
          element.quesListToStore.forEach((element, indexAfterSliced) => {
            element.indexToSave = indexAfterSliced.toString();
            element.questionList.forEach(ques => {
              ques.index = indexAfterSliced.toString();
            });
          });
        }
      });
    }
  }

  assignDirectValueToMedicationQuestionList(value: TabQuesObjList[]): void {
    this.tabQuesObjList = value;
  }

  getMedicationQuestionList(): TabQuesObjList[] {
    return this.tabQuesObjList;
  }

  setRefJsonWithMappingQId(value: RefJsonQuestion[]) {
    this.refJsonWithMappingQId = [];
    this.refJsonWithMappingQId = value;
  }

  getRefJsonWithMappingQId(): RefJsonQuestion[] {
    return this.refJsonWithMappingQId;
  }

  setMedicalConditionJson(value: Sections[]) {
    this.medicalConditionJson.next(value);
  }

  getMedicalConditionJson(): Observable<Sections[]> {
    return this.medicalConditionJson.asObservable();
  }

  emitEventForBusinessValidation(value: any) {
    this.businessValidationEvent.next(value);
  }

  setRangeValidationJson(value: rangeData[]) {
    this.rangeValidationJson.next(value);
  }

  getRangeValidationJson(): Observable<rangeData[]> {
    return this.rangeValidationJson.asObservable();
  }

  setMedicationJson(value: Sections[]) {
    this.medicationJson.next(value);
  }

  getMedicationJson(): Observable<Sections[]> {
    return this.medicationJson.asObservable();
  }

  setInitialQuestionJson(value: CurrentMedConToDisplay) {
    this.initialQuestionJson.next(value);
  }

  getInitialQuestionJson() {
    return this.initialQuestionJson.asObservable();
  }

  setMCDashboardObj(value: boolean) {
    this.mcDashboardObj.next(value);
  }

  getMCDashboardObj() {
    return this.mcDashboardObj.asObservable();
  }

  setMCSubAndClassificationObj(value: SubAndClassificationModel) {  
    if(value){
      let temp: SubAndClassificationModel[] = this.subAndClassificationObj;
      let matchQuesFound: boolean;
      let i = temp.length
      while (i--) {
  
          if (temp[i].mapQuesId === value.mapQuesId) {
              temp.splice(i, 1);
          }
      }
      temp.push(value);
      this.subAndClassificationObj = [];
      this.subAndClassificationObj = temp;
    }    
  }

  setMCSubAndClassificationObjAsEmpty(value: SubAndClassificationModel[]) {
    this.subAndClassificationObj = [];
  }

  getMCSubAndClassificationObj(queIdWithPrefix: string): SubAndClassificationModel {
    if(this.subAndClassificationObj && this.subAndClassificationObj.length > 0){
      let result = this.subAndClassificationObj.find((element) => element.mapQuesId === queIdWithPrefix);
        if (result) {
          return result;
        }
        else{
          return null;
        }
    }
    return null;
  }

  setBackNavData(value: BackDataStoreModel) {
    this.currentBackNavData.next(value);
  }

  getBackNavData() {
    return this.currentBackNavData.asObservable();
  }

  setEditMode(value: boolean){
    this.isEditModeCondition.next(value);
  }

  getEditMode(){
    return this.isEditModeCondition.asObservable();
  }

  setEditMedConditionIndex(value: EditMedIndexModel){
    this.currentMedConditionIndex.next(value);
  }

  getEditMedConditionIndex(){
    return this.currentMedConditionIndex.asObservable();
  }

  getAccordionBtnObj(): AccordBtnModel {
    return this.accordObj;
  }

  setAccordionBtnObj(value: AccordBtnModel) {
    this.accordObj = value;
  }

  getAccordIndexToPrepareBackEndJson(): number[] {
    return this.accordIndexToPrepareBackEndJson;
  }

  setRegisterBackData(value: RegisterBackNavModel) {
    this.registerBackData.next(value);
  }

  getRegisterBackData() {
    return this.registerBackData.asObservable();
  }

  setIndexToPrepareBackEndJson(value: number[]) {
    this.accordIndexToPrepareBackEndJson = value;
  }

  addAccordIndexToPrepareBackEndJson(tempAccordIndex: number) {
    if (tempAccordIndex === 0 || tempAccordIndex) {
      this.accordIndexToPrepareBackEndJson.push(tempAccordIndex);
    }
  }

  removeAccordIndexToPrepareBackEndJson(tempAccordIndex: number) {
    if (tempAccordIndex === 0 || tempAccordIndex) {
      const index = this.accordIndexToPrepareBackEndJson.indexOf(tempAccordIndex);
      if (tempAccordIndex > -1) {
        this.accordIndexToPrepareBackEndJson.splice(index, 1);
      }
    }
  }
  setToggleError(errorValue: ErrorMsgModel): void {
    // removed duplicate index if any
    this.errorValue.forEach((element, index) => {
      if (element.questionId === errorValue.questionId) {
        this.errorValue.splice(index, 1);
        // element.quesListToStore.sort((a: any, b: any): number => {
        //   return a.indexToSave - b.indexToSave;
        // });
      }
    });
    this.errorValue.push(errorValue);
  }
  deleteToggleError(errorValue: ErrorMsgModel): void {
    this.errorValue.forEach((element, index) => {
      if (element.questionId === errorValue.questionId) {
        this.errorValue.splice(index, 1);
        // element.quesListToStore.sort((a: any, b: any): number => {
        //   return a.indexToSave - b.indexToSave;
        // });
      }
    });
  }
  getToggleError(questionId): ErrorMsgModel[] {
    const arrError = this.errorValue.filter(error => {
      return error.questionId === questionId;
    });
    return arrError;
  }
}
